export const SEARCH_URL = `https://api.mapbox.com/geocoding/v5`;

export const TEMP_URL = `${SEARCH_URL}/mapbox.places`;
export const PERMANENT_URL = `${SEARCH_URL}/mapbox.places-permanent`;
